import { Outlet } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useStore } from "../zustand/store";
import Cookies from "js-cookie";
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import Alert from "../components/Alert"
import TabNavigation from "./TabNavigation"
import TrackingScripts from "../components/TrackingScripts";
import { hitApi } from "../components/commonAction";


const Layout = () => {
    const navigate = useNavigate();
    let store = useStore(state => state)
    let { token, role, source } = store.userData;
    let cookieToken = Cookies.get('authToken');
    let authPage = ['/', '/login'];
    let publicPages = ['/terms-conditions', '/privacy-policy', '/pricing', '/tiers', '/affiliate-program'];
    let currentPath = useLocation().pathname;
    let [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        (async function(){
            try{
                hitApi({
                    url: `accounts/getAllAppsDetails`,
                    method: "GET",
                    data : {}
                }, (resp,error) => {
                    store.updateStore("appList", resp.integratedApp);
                });
            }catch(error){
                console.log(error,'error')
            }
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // Show "My Billing" in the sidebar for all authenticated users.
    useEffect(() => {
        if (!token || !cookieToken) return;
        store.updateStore('billing', { ...store.billing, hasActivity: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, cookieToken]);

    // Affiliate ?ref= capture (Phase 3): on any route, if a ?ref=CODE is present
    //   1. ping /billing/referral/:code so the click gets logged + the
    //      server-side cookie is set (works for same-origin deployments).
    //   2. ALSO store the code in localStorage with a 30-day TTL — this is
    //      what survives across navigations in dev where the SPA (:4657) and
    //      API (:4658) are different origins, so the HTTP cookie never makes
    //      it back on cross-origin XHR. The checkout pages read it from
    //      localStorage and pass it explicitly to /billing/checkout/*.
    //   3. strip the ?ref param so it doesn't pollute bookmarks.
    useEffect(() => {
        const ref = searchParams.get('ref');
        if (!ref) return;
        hitApi({
            url: `billing/referral/${encodeURIComponent(ref)}?path=${encodeURIComponent(currentPath)}`,
            method: 'GET',
            data: {},
            alert: false,
        }, () => {});
        try {
            // 30-day TTL matches the default cookieDurationDays setting.
            const ttlMs = 30 * 24 * 60 * 60 * 1000;
            localStorage.setItem('pxl_ref', JSON.stringify({
                code: ref,
                expiresAt: Date.now() + ttlMs,
            }));
        } catch (_) {
            // localStorage unavailable (private mode, etc.) — silent fail
        }
        const next = new URLSearchParams(searchParams);
        next.delete('ref');
        setSearchParams(next, { replace: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParams.get('ref')]);


    useEffect(() => {
        // Allow public pages (incl. /tiers)
        if (publicPages.includes(currentPath)) {
            return;
        }

        // 1. If no token (store OR cookie) → block protected pages
        if (authPage.includes(currentPath) === false && !token && !cookieToken) {
            navigate('/');
            return;
        }

        // 2. If token mismatch → logout user
        if (token && cookieToken && token !== cookieToken) {
            store.updateStore("userData", {});
            Cookies.remove('authToken');
            navigate('/');
            return;
        }

        // 3. User logged in but trying to access login/register page
        if (token && token === cookieToken && authPage.includes(currentPath)) {
            if(!source){
                let dest = '/dashboard';
                if (role === 'admin')      dest = '/admin';
                else if (role === 'affiliate') dest = '/affiliate/dashboard';
                navigate(dest);
            }
            store.updateStore("userData", {...store.userData, source : null});    //removing source once its redirect to actual source
            return;
        }
    }, [currentPath, token, cookieToken, role]);


    return (
        <>
            <TrackingScripts />
            <Outlet />
            <Alert />
            <TabNavigation />
        </>
    )
};

export default Layout;